module.exports = __webpack_public_path__ + "img/zy.809e491d.png";